import { render, staticRenderFns } from "./ResourceStatsForm.vue?vue&type=template&id=2428129a&"
import script from "./ResourceStatsForm.vue?vue&type=script&lang=js&"
export * from "./ResourceStatsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports